export const sortingInformationList = [
  {
    key: 'max_team_member',
  },
  {
    key: 'max_socmed_account',
  },
  {
    key: 'email_support',
  },
  {
    key: 'base_features',
    text: 'Social account advance management',
  },
  {
    key: 'post_integration',
    text: 'POS integration reporting',
  },
  {
    key: 'roles_management',
    text: 'User roles management',
  },
  {
    key: 'assigned_accounts_partner',
    text: 'Assigned account partner',
  },
];

export const sortingCompareLicense = [
  {
    title: 'Feature',
    key: 'name',
  },
  {
    title: 'Client Users',
    key: 'max_team_member',
  },
  {
    title: 'Social Accounts',
    key: 'max_socmed_account',
  },
  {
    title: 'Email Support',
    key: 'email_support',
  },
  {
    title: 'Base Features',
    key: 'base_features',
  },
  {
    title: 'Social Accounts Calender',
    key: 'social_accounts_calender',
  },
  {
    title: 'Social Accounts Stream',
    key: 'social_accounts_stream',
  },
  {
    title: 'Social Accounts Messaging',
    key: 'social_accounts_messaging',
  },
  {
    title: 'Social Accounts Posting',
    key: 'social_accounts_posting',
  },
  {
    title: 'Add More Social Accounts',
    key: 'add_social_accounts',
  },
  {
    title: 'Social Advertising Publishing',
    key: 'social_advertising_publishing',
  },
  {
    title: 'Social Advertising Calendar',
    key: 'social_advertising_calender',
  },
  {
    title: 'Social Advertising Reporting',
    key: 'social_advertising_reporting',
  },
  {
    title: 'POS Integration Reporting',
    subtitle: '(Only with POS Integration)',
    key: 'post_integration_reporting',
  },
  {
    title: 'Add POS Integration',
    key: 'post_integration',
  },
  {
    title: 'Create & Assign Roles',
    key: 'roles_management',
  },
  {
    title: 'Add More Client Users',
    key: 'add_client_users',
  },
  {
    title: 'Assigned Account Partner',
    key: 'assigned_accounts_partner',
  },
];
